import { object, string } from 'yup';

export const step1Schema = object({
  code: string()
    .required('Обязательное поле')
    .matches(/^\d{4}$/, 'Введите 4 цифры'),
});
